import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CollapsableHolidaySummary from "app/pages/Booking/HolidaySummary/CollapsableHolidaySummary/CollapsableHolidaySummary";
import {
	calculateCreditBasedOnQuoteBase,
	calculatePreBookTotal,
	getQuoteTotalWithDelta,
	getSavingsData,
} from "app/pages/Booking/bookingSelectors";
import { matchPath } from "react-router-dom";
import withRouter from "app/utils/hocs/withRouter";
import { PAYMENT_TERMS } from "app/constants";
import {
	getEcheancier,
	isRecalculatingPricesForPayment,
} from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = (state, ownProps) => {
	const currentPathname = ownProps.location.pathname;

	const isRestoreBookingSessionPage = matchPath(
		{
			path: "/booking/restoreSession",
		},
		currentPathname
	);

	const isPaymentPage = matchPath(
		{
			path: "/booking/payment",
		},
		currentPathname
	);

	const isSDPPaymentPage = matchPath(
		{
			path: "/sdp/booking/payment",
		},
		currentPathname
	);

	const booking = state.booking || {};

	const paymentMode = booking.paymentMode;

	const isMultipleInstalmentsPayment = paymentMode >= PAYMENT_TERMS["4x"];

	const mensualite = getEcheancier(state);

	const paymentTotal = getQuoteTotalWithDelta(state);

	const paymentTotalWithCreditFees = isMultipleInstalmentsPayment
		? paymentTotal + mensualite.coutCredit
		: paymentTotal;

	const total =
		isPaymentPage || isSDPPaymentPage || isRestoreBookingSessionPage
			? paymentTotalWithCreditFees
			: calculatePreBookTotal(state) - calculateCreditBasedOnQuoteBase(state);

	// restoreSession = contexte paiement : même `total` (l.53-56), peut aussi déclencher FETCH_USABLE_COUPONS.
	const isPaymentContext = Boolean(
		isPaymentPage || isSDPPaymentPage || isRestoreBookingSessionPage
	);

	return {
		totalPrice: total,
		coutCredit: mensualite.coutCredit,
		savingsTotalAmount: getSavingsData(state).amountSaved || 0,
		isLoading: isRecalculatingPricesForPayment(state.usableCoupons.status, isPaymentContext),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({}, dispatch);
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(CollapsableHolidaySummary)
);
